
//정규식숫자체크
const regexNumberCheck = (value) => {
    const regex = /^[0-9]+$/;
    if(regex.test(value) || value === "") return true;
    return false;
}

export {regexNumberCheck}